module.exports = __webpack_public_path__ + "img/boy_010011.ce0dbf14.png";